import { CoderiaLogo } from './CoderiaLogo';
import { useTranslation } from '@/lib/i18n';
import { getDomainConfig } from '@/lib/config';

export function Footer() {
  const { t } = useTranslation();
  const config = getDomainConfig();

  return (
    <footer className="w-full py-4 px-4 flex-shrink-0 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
        <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
          {t('footer.poweredBy')}
        </p>
        <a
          href={config.companyWebsite}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-900 dark:text-white hover:opacity-70 transition-opacity"
          aria-label={config.companyName}
        >
          <CoderiaLogo className="h-6 w-auto" />
        </a>
      </div>
    </footer>
  );
}
